module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("2")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "_idParaDest-5",
      "title": "2 H. R. Rookmaaker, Modern Art and the Death of a Culture"
    }
  }, [_vm._v("H. R. Rookmaaker, "), _c('i', [_vm._v("Modern Art and the Death of a Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("One thing binds all these [modernist] groups and arts together: the assertion that reality is at stake, that it has become a question-mark, that it seems to be something man cannot be happy with, something that is strange to him. Crisis, alienation, absurdity, it is words like these which describe the artistic situation.")]), _vm._v(" "), _c('p', {
    staticClass: "epi_source"
  }, [_vm._v("H. R. Rookmaaker"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-223-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("In the last few decades, what other single piece of writing has had more influence on Christian artists? . . . What other book has done more to provide a specifically Christian intellectual environment for the practice and understanding of art?")]), _vm._v(" "), _c('p', {
    staticClass: "epi_source"
  }, [_vm._v("Jeremy Begbie"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-222-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("The tendency has been, at least since Rookmaaker, to paint as dire a picture as possible of the history of modern art and the contemporary art world.")]), _vm._v(" "), _c('p', {
    staticClass: "epi_source"
  }, [_vm._v("Daniel A. Siedell"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-221-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_vm._v("One of the many factors contributing to the critical estrangement between modern art and religion in the twentieth century was the relative paucity of religious voices in the writing of modern art history and criticism. The artistic avant-garde may well have been aggressively disentangling itself from Western religious (Christian) traditions and institutions, but, as noted in the last chapter, the acts of estrangement were certainly reciprocated: well-educated, devout Christians collectively shunned the modern art discourse for much of the twentieth century and thereby contributed very little to the construction of its primary narratives. Christians from across the denominational spectrum tended to see modern art as deeply antagonistic to religious belief, and, as we’ve seen, so too did many historians of modern art. There are a few exceptions, but for the most part the writing that has been most formative to developing the “grain” of the primary modernist narratives—especially those written from the 1920s through the 1990s—were constructed with little critical reflection on the religious and theological implications of the artworks in question.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In the 1960s and 1970s a handful of Christian academics began to emerge into this space of mutual estrangement and attempted to engage modern art from a range of Christian positions."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-220-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" The most influential of these scholars among evangelical Christians was Hendrik (Hans) Roelof Rookmaaker (1922–1977), professor of art history at the Free University of Amsterdam (where one of the present authors—Bill—studied with him in the 1970s). Rookmaaker began speaking and writing about Christianity and modern art at a time when few others were and with a rare forthrightness, sophistication and charisma. Calvin Seerveld was perhaps his most significant peer in this respect."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-219-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" Rookmaaker traveled and lectured widely in Britain and the United States during the 1960s and 1970s, attracting a great number of young Christians to his views. For many evangelicals his lectures and essays became a primary means of making modern art—and visual and musical culture more generally—a viable and vital arena for serious Christian thinking and participation.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("These lectures were eventually developed into his best-known and most influential work, "), _c('i', [_vm._v("Modern Art and the Death of a Culture")]), _vm._v(", a popular-level account of modern art that first appeared in 1970."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-218-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" This book served two primary aims: (1) it was an argument for a renewed Christian participation in the visual arts, and (2) it was an argument for a particular interpretation of modern art history.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("On the one hand, the book was aimed at adjusting pervasive assumptions and attitudes about the visual arts on the part of North Atlantic Christians. Ultimately, it was a kind of rallying cry for Christians to reengage the visual arts and the attendant academic discourses about the arts. Rookmaaker lamented that “for so long Christians have taken no part in artistic discussion or activity,” which he attributed to chronic deficiencies and failures in "), _c('i', [_vm._v("theological")]), _vm._v(" thinking, particularly with regard to the Western church unwittingly imbibing “gnostic” and “mystical” streams of thought that pit spirituality and holiness against materiality and embodiment."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-217-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" He saw these streams spilling across denominational lines—he specifically highlights dualisms within Anabaptist, Puritan and Roman Catholic thought"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-216-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v("—and he devoted a significant portion of the book (and his career) to redressing these theologies with a more thoroughgoing “Reformation attitude.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-215-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" He argued that one of the principal insights of Reformed Christianity is that in fact “there is no duality between a higher and a lower, between grace and nature. This world is God’s world. He created it, He sustains it, He is interested in it. He called the work of His hands good in the very beginning. Nothing is excluded.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-214-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" Christians must therefore not think along binaries that divide the spiritual from the material. Rather, he argued, the only truly Christian duality exists between “the kingdom, the rule, the realm of God and the kingdom of darkness. . . . This is the true division. It goes through all mankind, affecting every human being; two opposite ways, one as God wants, the other against His will.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-213-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" This ­division is thus not a matter of metaphysical dualism as much as it is moral, ethical and aesthetic: “There is a duality, between good and bad, right and wrong, beautiful and ugly.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-212-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" Ultimately, Rookmaaker’s aim in his book was to trace and clarify "), _c('i', [_vm._v("this")]), _vm._v(" duality as it runs through modern art, while upholding art as a good in itself.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The theological problems wound up in the varieties of acultural or anticultural “mysticism” in Western society have, he believed, harmed both the church and the art world. As he saw it, the evacuation of Christians from the modern art discourse not only “allowed” the arts “to become completely secular”;"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-211-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" it also rendered the church profoundly culturally impoverished, both in terms of its intellectual resources—“Any sort of critical way of thinking [about the arts] is almost completely lacking [among evangelical Christians]”—and in terms of its artistic community and enculturation: “Many want to be artists in a Christian sense—but have to find the answers for themselves.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-210-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" In each case the result is a reduced form of life: “If the world’s system was a secularized one, missing true spirituality, the Christians’ attitude also became a reduced one, missing its foundation in reality due to lack of interest in the created world. . . . In concentrating on saving souls [Christians] have often forgotten that God is the God of life.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-209-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Beyond its call for Christian reengagement in the arts, "), _c('i', [_vm._v("Modern Art and the Death of a Culture")]), _vm._v(" is, on the other hand, also a particular narration and interpretation of modern art history, which he begins in about 1800 with Francisco de Goya (1746–1828) and extends through the 1960s with some cursory attention paid to pop art, happenings, minimalism and conceptualism."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-208-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" In many ways it is a deeply negative account (as might seem rather straightforwardly indicated by the book’s title), but the character of and reasons for this negativity are complex and mingled with relentless evangelical optimism. The book is manifestly a product of its time, and much of its negativity comes into sharper focus as we sensitize ourselves to the historical context from which it emerges and to which it was aimed. Written in the mid to late 1960s, this book took form in the midst or immediate memory of the Cuban Missile Crisis (1962), the height of the American civil rights movement and its accompanying racial violence (1963–1968), the international student and worker uprisings of May 1968, the bloodiest years of the Vietnam War (1967–1969), the assassinations of Martin Luther King Jr. and Robert Kennedy (1968), and the massive emblematic countercultural event in Woodstock (1969). A strong sense of international conflict and sociopolitical instability is palpable throughout the text. The first sentences of the book open and orient the train of thought with precisely this instability in view: “We live at a time of great change, of protest and revolution. We are aware that something radical is happening around us, but it is not always easy to see just what it is.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-207-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" This historical location for the book makes it feel dated and alarmist today (four and a half decades later), but it also makes more intelligible—and elicits greater sympathy for—the sense of urgency and fear that characterizes its train of thought.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In some ways Rookmaaker’s stance was classically conservative: he feared the consequences of the changes that were taking place in the culture more than he was expectant that these changes were signs of progress toward more just or peaceful social configurations. His narrative of history includes a strong sense of loss and impending disaster; indeed, he believed that Western culture was clearly (though not inevitably) in the process of suffering some kind of “death.” At the same time, however, he is decidedly not conservative in his trenchant criticism of the “bourgeois” character of North Atlantic Christianity, especially regarding its general preoccupations with money, social status, security, technology, sentimentality, rationalism, moralism and sexuality."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-206-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" He saw in the “progress” of Western modernity—both within and without the church—an increasingly dire unbalancing: the image of a pendulum swinging between extremes is a favored metaphor throughout the book.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The tenor of Rookmaaker’s book might also be interpreted in the context of his own life, though we don’t have space here to explore this in any sufficient detail."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-205-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" After growing up in the colonial Dutch East Indies—an upbringing that almost certainly heightened his sensitivities to how Western culture might look from the outside"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-204-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v("—he returned to Holland and enlisted in the Royal Netherlands Naval College prior to the Nazi occupation in 1940. The years of World War II would be deeply transformational for him. In March 1941 he was arrested for possession of anti-Nazi literature—a pamphlet titled "), _c('i', [_vm._v("De vrije Katheder")]), _vm._v(" (The Free Podium)—and spent most of the next four years in prison and in Nazi prisoner-of-war camps."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-203-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" It was during this time that he became a Christian.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("By his own account he was raised in “a family that can in no way be described as religious,” but soon after arriving in Nuremburg as a prisoner of war, Rookmaaker began reading the Bible. As he later recalled: “There were no other books available and, as a civilized man with cultural interests, I thought it would be good to know something about it.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-202-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" He studied the text with increasing care, filling the margins of his copy with notes and cross-referential commentary—a process that deeply altered his thinking. In late 1942 Rookmaaker’s camp was moved to Stanislau (now in Ukraine), which, as David Bruce Hegeman puts it, “turned out to be a virtual university,”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-201-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" given the large number of officers and intellectuals imprisoned there. While at this camp Rookmaaker was tutored in Latin and Greek; he had access to numerous books on philosophy and history that changed hands among prisoners; and (perhaps most significantly) he met the Christian philosopher J. P. A. Mekkes, who would have an enduring impact on his life and thought. Mekkes loaned Rookmaaker his copy of Herman Dooyeweerd’s massive three-volume "), _c('i', [_vm._v("De Wijsbegeerte der Wetsidee")]), _vm._v(" ("), _c('i', [_vm._v("A New Critique of Theoretical Thought")]), _vm._v(", 1935–1936), which Rookmaaker “devoured,” and Mekkes mentored him through what amounted to a “Dooyeweerdian catechism.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-200-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" Rookmaaker emerged from the POW camps of World War II a deeply devout Christian, well schooled in the neo-Calvinism of Abraham Kuyper and Dooyeweerd and intensely interested in the possibilities for doing cultural criticism from such a position. Following the war he became well read in Reformed theology and grew attentive to the growing movement of evangelicalism in North America and Britain. In 1948 he met the American evangelist Francis Schaeffer, who would become a lifelong personal friend and collaborator."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-199-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("After the war Rookmaaker studied for his PhD in art history at the University of Amsterdam, focusing on the work of Paul Gauguin."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-198-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" He was particularly drawn to what he called the “iconic” aspect of Gauguin’s work, by which he meant the potential for artworks to represent the meaningful “structure of things” without necessarily depicting their naturalistic appearance."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-197-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" As we’ll see later in this chapter, this distinction between “structure” and “appearance” that he developed in his study of Gauguin remained central to his interpretive method throughout his career. He believed that this notion of the “iconic” that he saw in Gauguin “has been of primary importance for the genesis and the development of modern French art,”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-196-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" though it is significant in the context of our project that Rookmaaker made no attempt to investigate the ways that this development—and its derivation from the traditions of religious icons—might have been influenced by Gauguin’s Catholic background (something we discuss in the next chapter). Instead, ­Rookmaaker’s own Reformed perspective made him especially attentive to the “humanity” in Gauguin’s work and his “adherence to reality” precisely while “he rejected naturalism.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-195-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" Indeed, these became the distinguishing (theological) preoccupations that would frame Rookmaaker’s entire account of modernist art history: what is most at stake in the arts is not how naturalistically they ­reproduce “appearances” but the ways in which they explore the “structure” of what it means to be human in this world. He felt that creation (and human creatureliness as such) was a good and extravagant gift of God, not a problem or a prison—and modern artworks could be judged according to their iconic handling of precisely that issue.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Rookmaaker’s work as an art historian developed in the convergence of all of these influences. He was a Kuyperian Christian who believed that art provided a salient “sign of the times,”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-194-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" and as such it badly needed spiritually sensitive reflection and cultural criticism. His experiences of World War II certainly shaped his sense of how much might be at stake in cultural discourse and in the exchange of ideas—including its aesthetic modes—and how potentially tragic and brutal a social ethos and the structures it produces can be. The formation of his Christian thinking and convictions specifically in the context of a Nazi prison camp likely amplified his sense of oppositional contrast between Christianity and secularism. As Graham Birtwistle notes, Rookmaaker’s declinist narrative of modern art directly links up to (and finds intellectual precedence in) similar breakdown narratives written by the Calvinist thinkers who influenced him most: his project, for example, very intentionally recalls Guillaume Groen van Prinsterer’s "), _c('i', [_vm._v("Lectures on Unbelief and Revolution")]), _vm._v(" (1847, rev. ed. 1868) and Herman Dooyeweerd’s "), _c('i', [_vm._v("In the Twilight of Western Thought")]), _vm._v(" (1960)."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-193-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" Rookmaaker also drew influence from a variety of art historians, perhaps especially from the controversial Roman Catholic and antimodernist Austrian art historian Hans Sedlmayr in his well-known "), _c('i', [_vm._v("Loss of the Center")]), _vm._v(" (1948) and "), _c('i', [_vm._v("The Revolution of Modern Art")]), _vm._v(" (1955). It might even be argued that Rookmaaker’s project was essentially to reconceive Sedlmayr’s art history from within a Dooyeweerdian framework."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-192-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In the convergence of all of these influences, "), _c('i', [_vm._v("Modern Art and the Death of a Culture")]), _vm._v(" emerged as a statement of Christian art criticism—and it did so with considerable effect. Malcolm Muggeridge featured "), _c('i', [_vm._v("Modern Art and the Death of a Culture")]), _vm._v(" as one of the four best Books of the Year in a December 1970 edition of "), _c('i', [_vm._v("The Observer")]), _vm._v(","), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-191-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" and it quickly shot to bestseller status, particularly among Christian readers.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_9"
    }
  }, [_vm._v("Art and Worldview")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("At the outset of "), _c('i', [_vm._v("Modern Art and the Death of a Culture")]), _vm._v(" Rookmaaker articulates the governing premises of his narrative of modern art history: “The issues at stake are not just cultural and intellectual but spiritual. What is involved is a whole way of thinking that leaves out of account, and so largely negates, vital aspects of our humanity and our understanding of reality.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-190-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" Packed into these lines are the contours of the entire book, in terms of both his method and his thesis.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("First, here we glimpse the method of “worldview” analysis that was fundamental to Rookmaaker’s art criticism."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-189-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _vm._v(" For him, the most significant aspect of any artwork is that it inevitably presupposes and is a product of “a whole way of thinking” about the world; it discloses and makes visible a particular orientation toward the world. Whether consciously or unconsciously, in majestic or seemingly trivial ways, any artwork made by a human person “always portrays reality in a human way” and thus inevitably “gives a particular view on reality.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-188-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" In this sense, Rookmaaker believed that artworks “give a philosophy of the world and of life,” and these philosophies can and must—for the sake of understanding the ways they are both reflecting and affecting us—be sensitively exegeted and interpreted."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-187-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("It is vital to note that for Rookmaaker the kind of “philosophy of the world and of life” that is most importantly manifested in an artwork is often much more basic than the conscious, cognitive ideas the artist had in mind while making the work. The worldview Rookmaaker is interested in includes the entire network of assumptions, affections and dispositions that locate, orient and motivate a person in and toward the world. Modernist paintings, no less than any other art forms, are significant not only for the ways they function as intentional expressions or statements of belief but also for the ways they (often unintentionally) disclose a “general spirit of the age.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-186-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" In other words, what interested Rookmaaker about any given artwork was the way that it reveals the complex structure of social and cultural moods, values and beliefs that underwrite and uphold the work at a deeper level than is ever fully in the field of any artist’s conscious intentions. And, once again, for him the deepest issues and concerns that are in play here are “not just cultural and intellectual but spiritual”—and they are not adequately understood until they are interpreted as such."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-185-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Furthermore, it is vital to note that he was looking for this disclosure of worldview to appear not only in the themes and subject matter taken up by an artist but, more importantly, in “the way the theme and the subject-matter were handled.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-184-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" For Rookmaaker, artists’ choices of what they turn their attention toward are less significant than how they construe and construct these subjects in artistic form: this, he believed, is where an artist’s deeper assumptions, dispositions and structures of belief—the artist’s “particular "), _c('i', [_vm._v("view")]), _vm._v(" on reality”—are most operative and discernible. And on this point, we can already see why his attentiveness to art as a "), _c('i', [_vm._v("picturing")]), _vm._v(" of the world would lead him to privilege painting over other visual art forms.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The subtle but important implication of Rookmaaker’s method is that it is the artwork itself that discloses worldview, and thus "), _c('i', [_vm._v("it")]), _vm._v("—not the artist—is the proper object of critical analysis. Regardless of whatever may have been in the minds of modern artists as they worked and spoke about their work, what is of primary importance is the concrete picturing of the world—the “handling” of subjects, themes and materials—that is embodied in the artworks themselves. It is, after all, the art object that “gives a particular view on reality, a philosophy,” not the artist per se."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-183-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" In other writings he repeatedly insisted on this point: “In the final analysis we are concerned with the critique of the concrete paintings. We must not judge the artist when we are looking at a picture, but consider the painting itself.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-182-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" In fact, “let there be no mistake: we are not saying that the artist determines the content, the thought, the idea that takes shape and is given form. That may sometimes be the case, but usually the artist . . . will only give form to the ideas that are ‘in the air,’ so to speak.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-181-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Second, beyond providing a sketch of his method, the lines quoted at the beginning of this section also offer a staging of Rookmaaker’s thesis and his chief complaints about modernist art. Namely, he argued that modernism misconstrues and in fact “largely negates” some of the most “vital aspects of [1] our humanity and [2] our understanding of reality.” In other words, Rookmaaker believed that modern art is fundamentally "), _c('i', [_vm._v("dehumanizing")]), _vm._v(" and "), _c('i', [_vm._v("disorienting")]), _vm._v(". Given his commitment to interpreting artworks in terms of the ways they convey and generate “views” of the “structure” of reality—that is, as a picturing of the world and a handling of the subjects that compose human life—he naturally interpreted the flattening, compressing, distorting and fracturing of visual space in modernist painting as manifesting and promoting a variety of flattened, compressed, distorted and fractured understandings of the realities themselves. It is on this basis that he was particularly troubled by the handling of the human form in modernist painting and the doubts it generates about our perceptions of reality. Those who studied with him remember his ability to find much in the work of Picasso or Klee to admire, but when he felt that the new languages of art represented an estrangement from reality or a distortion of humanity, he protested.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_10"
    }
  }, [_vm._v("An Age of Crisis")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("On the basis of his pictorial worldview analysis, the story of modern art history that Rookmaaker tells is of a gradual decline into nihilism and absurdism. He did not think that modern art is itself responsible for this decline—he considered it symptomatic of a dying culture but not a cause of it, and perhaps not even a serious contributor to it. The villain in Rookmaaker’s narrative is not artistic modernism but the Enlightenment, the intellectual engine of what we have been calling modernity: “Modern art did not just happen. It came as a result of a deep reversal of spiritual values in the Age of Reason, a movement that in the course of a little more than two centuries changed the world.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-180-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _vm._v(" As he saw it, the character of this reversal and the fundamental effect of Enlightenment thinking was that “however gently, [God] was pushed out of the door.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-179-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" The primary mechanism of this push was an overly optimistic (and increasingly materialist) rationalism for which “there is nothing more in the world but what the senses can perceive and reason can apprehend” and in which “the only way to come to any understanding of [the universe] is to use our senses (seeing, hearing, weighing, measuring) and to use our reason to coordinate the sensations or perceptions we have had.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-178-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _vm._v(" By this path, he argues, Enlightenment science became a pseudoreligious “scientism,” promising “the revelation of the new world” and demanding only that devotees “cling superstitiously to the word scientific as true to reality. But it is a reduced reality.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-177-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Thus we need to be careful about exactly which “culture” and which “death” we assume the title of his book references. We might initially suppose—and many readers have supposed—that Rookmaaker’s book was a panicked warning about the death of Western "), _c('i', [_vm._v("Christian")]), _vm._v(" culture, wherein modern art is identified as a clear symptom of the disease(s) afflicting it. This view is certainly supportable from the book itself, but it is also clear that the dying cultural ethos he has in mind is already significantly post-Christian."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-176-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _vm._v(" The book might be more precisely addressed to “Modern Art and the Death of "), _c('i', [_vm._v("Enlightenment")]), _vm._v(" Culture”—his primary aim being to consider what modern art tells us about what happens "), _c('i', [_vm._v("after")]), _vm._v(" modernity."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-175-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" The first page of the book declares Rookmaaker’s overarching intention: “My aim in this book is to show the relationship between the great cultural revolution of our time [modernism] and the general spirit of the age [modernity]—an age which, as we shall see, would seem to be drawing to a close.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-174-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _vm._v(" In the waning of this Age of Reason, modern art appears (in Rookmaaker’s reading) as a tragic, quixotic protest against modernity­—tragic because it ingests the same underlying nihilism of modernity that it attempts to revolt against and quixotic because it misidentifies the “much greater crisis.” As he puts it in his last (unfinished) book, “This greater crisis is of a spiritual nature and, as such, affects all aspects of society including economics, technology and morality.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-173-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _vm._v(" With this he reverses at least one of the causal arrows assumed by the modern secularization thesis: spiritual crisis gives shape to modernization, not simply vice versa.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Rookmaaker never mentions Max Weber in any of his writings, nor are there any indications that he ever read his work, but his discussions of scientism can be mapped onto Weber’s descriptions of the modern “disenchantment of the world” (see chapter one). Rookmaaker accuses scientistic rationalism of constructing “a reduced reality” insofar as it required that “the world was no longer open to a transcendent God. It had become a closed box, and man was caught in that box.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-172-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _vm._v(" And for Rookmaaker this is not simply an abstract problem; it is utterly concrete in its everyday social, political and economic implications: under the regime of scientism humans increasingly become units in the mechanics of technocracy and consumerism.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Over against these dehumanizing undercurrents of modernity, Rookmaaker believed that existentialism (following Kierkegaard) and avant-garde modernism (following Baudelaire) mounted vital protests: “They have told man to jump out of the box. . . . You are more than matter, more than the naturalistic sciences can tell you.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-171-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" In fact, in numerous places he asserts that the chief virtue of modernism was precisely its will to protest on this point (taking the oppositional stance described in the last chapter), even though he also believes that it erred in not protesting deeply enough: Christians “must realize that the protesters and revolutionaries are often fighting against the same evils of society as they are themselves. But they must also see the inadequacy of all answers that do not tackle the root of the problem.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-170-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _vm._v(" For Rookmaaker, the “root of the problem” is that God has been excised: the world will always remain disenchanted, humans will continue to be dehumanized and ethical norms will remain undecidable—in short, the world will always be a “closed box”—as long as we live as though the world is mechanically closed to the Giver (and the Giving) of being itself."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-169-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _vm._v(" In its simplest terms, Rookmaaker’s argument (1) pits modernism’s avant-garde against modernity’s scientistic rationalism, (2) faults both of them for harboring an inescapable nihilism"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-168-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])]), _vm._v(" and then (3) posits (Reformed) Christianity as the only viable ground for a third way.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_11"
    }
  }, [_vm._v("A Declinist Art History")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Rookmaaker’s historical narrative traces the development of modernist art through three “steps.” The first step spans the nineteenth-century transition from romantic to realist painting, which he sees as playing out a series of epistemological crises and “deep spiritual problems” generated by the Enlightenment."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-167-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])]), _vm._v(" As modern scientism sought naturalistic explanations for every dimension of human experience, it proceeded by methodically demanding empirical and rational verification for each aspect of human belief. The necessary flip side of this was that all perceptions, all received conventions, all traditional explanations must be procedurally doubted and subjected to this same process of authentication—they might well survive but only as rigorously reconstructed with the tools of logic and scientific method. This placed pressure especially on those deliverances of history that held most sway over human lives: inherited forms of cosmology, political hierarchy and religious tradition were all subjected to deep and sustained efforts to “demythologize” whatever verifiable truths might be contained within them. Christianity, for instance, was distilled down to a more credible "), _c('i', [_vm._v("Religion Within the Bounds of Bare Reason")]), _vm._v(" (Immanuel Kant, 1793), the Bible was dissected and intensely scrutinized by higher biblical criticism, and (as Rookmaaker points out) theology was reconstructed through the demythologizing skill of scholars like Rudolf Bultmann."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-166-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Many positive developments (and many necessary corrections) emerged from this methodical doubt, but according to Rookmaaker it was also reductive, extensively unraveling an intricate and longstanding weave of religious, political and social ideals. And this had considerable implications for visual art, pressing artists increasingly toward empirical observation and casting the various grand traditions into their own processes of demythologization, by which the once-celebrated modes of dramatic storytelling, theological commentary and neoclassical poesis became increasingly problematic. Indeed, “the problem for the artist was now what to paint, what to see.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-165-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _vm._v(" Rookmaaker tracks the ways that “thematic” subject matter gradually collapsed in the nineteenth century: whereas art once devoted itself to meditating on the meanings of history, the Scriptures and mythopoeic archetypes, now the old “principles of choosing subject-matter” were abandoned in favor of more thoroughly naturalized meanings."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-164-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])]), _vm._v(" Where once there was Venus (an allegorical embodiment of transcendent Love and Beauty), now there were wholly immanent “nudes”; where once landscape paintings celebrated the sphere of God’s common grace, now they were simply artifacts of immediate sense perception; and so on.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Faced with enduring epistemological doubts about “the true source of knowledge,”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-163-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])]), _vm._v(" painters like Gustave Courbet (1819–1877) and Édouard Manet (1832–1883) painted what they saw without any predetermined narrative or iconographic meaning governing what they depicted. In fact, they actively subverted and degraded the old thematic principles and ideals. Manet’s "), _c('i', [_vm._v("Luncheon on the Grass")]), _vm._v(" (1863), for example, is a particularly clear instance of an artist turning the thematic traditions of painting against themselves: here the conventions for painting a multifigure narrative, a landscape, a still life, a nude and even a bather are wound into a single incoherent picture constructed with obvious spatial incongruities, irreconcilable sources of light and a scandalizing (and scandalizingly “low”) narrative. And all this is presented at the massive scale reserved for the grand statements of history painting. It is a Salon painting meant to confound—and to be highly critical of—the thematic conventions of the Salon. Manet’s "), _c('i', [_vm._v("Olympia")]), _vm._v(" (1864), from the following year, similarly recasts the Salon (and its crowds of idealized nudes) as a kind of intellectual brothel. Rookmaaker states the historical progression evocatively: “To Titian she had been Venus, to Goya a mistress,” but to Manet “a prostitute.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-162-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])]), _vm._v(" And thus the first step toward modern art: “Themes in the old sense had become obsolete.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-161-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Rookmaaker identifies the second step with impressionism, particularly the paintings that Claude Monet (1840–1926) made after 1885. Following on the heels of Courbet and Manet, subject matter continued to lose importance, and artists became increasingly preoccupied with the epistemological status of vision. In other words, painting shifted its attention from the symbolic and thematic meanings of "), _c('i', [_vm._v("what")]), _vm._v(" was seen to the sensory experience of "), _c('i', [_vm._v("seeing itself")]), _vm._v(". And Monet’s mature paintings pushed this shift very far indeed: he does not present a solid world of things as much as he rigorously “recorded what reached his eyes, the light beams that caused a sensation on his retina”—which for Rookmaaker implied an epistemological crisis at the most basic level: “the question is whether there is something behind them, a reality of things that caused the light beams.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-160-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])])]), _vm._v(" For reasons that are unclear, Rookmaaker believed that Monet’s work promoted the conclusion that in fact “there is no [knowable] reality. Only sensations are real.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-159-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])]), _vm._v(" He characterized this extreme epistemological doubt as the second step. In fact, he thought this was the “decisive step” that marks the birth of modernist art as such."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-158-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The postimpressionist paintings of Paul Gauguin (1848–1903), Vincent van Gogh (1853–1890), Georges Seurat (1859–1891) and Paul Cézanne (1839–1906) form a moment of suspension in Rookmaaker’s telling of the development (or degeneration) of modern art. Rookmaaker retained sympathy especially for Gauguin, who had been the subject of his doctoral dissertation. In many ways Gauguin and his fellow postimpressionists appear as the tragic heroes of Rookmaaker’s narrative: “These four tried to solve the problem, to regain the ground, to bring humanity and reality back into art. . . . They looked for a way to find something of the true values and the lasting principles of reality, the deeper universal.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-157-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])])]), _vm._v(" Specifically, he saw their work as attempting to forge a “synthesis” between the positivist “principle of starting from sense-perception to gain knowledge of the universe” and the antipositivist “principle of human freedom, the search for a humanist humanity,” thus “bringing together the best of the two opposing streams.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-156-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])]), _vm._v(" In fact, he thought they had achieved this synthesis so elegantly that he crowned their work as “probably the fullest and richest the world had seen since the seventeenth century.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-155-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])])]), _vm._v(" Ultimately, however, “the harmony they achieved was an unstable one . . . soon to be broken,” throwing these competing principles into discord."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-154-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])]), _vm._v(" And the effects might be understood as deeply damaging: from this point forward, according to Rookmaaker, “the personal, the human, the ‘real’” became increasingly “lost” in modernist painting."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-153-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Whereas the postimpressionists had sought “an equilibrium,” with the advent of French fauvism and German expressionism “the pendulum swung completely to the side of the freedom of the artist,” unhampered by the demands of either naturalism or decorum."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-152-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])])]), _vm._v(" Ultimately it would be Pablo ­Picasso (1881–1973) and then Marcel Duchamp (1887–1968) who would take a definitive “final step.” Rookmaaker represents Picasso as clearly understanding what was at stake in the previous two “steps”—which is why he thinks Picasso appears to hesitate around 1909—but eventually")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Picasso must have realized that [the postimpressionists’] quest had failed. They had searched for the universal, the general structure of things, that which is more than the strictly individual and specific—and in doing so had lost the personal, the human, the “real.” . . . [Picasso] accepted the failure, and took the consequences. There are no universals. The general, the absolute, is non-­existent. And if there are no universal principles, if there are no absolutes, then . . . we can understand his hesitation . . . then this world is absurd, nonsensical, without meaning."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-151-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("And with this, Rookmaaker’s narrative launches into increasingly negative proclamations: “Picasso, in breaking through the barriers of reality, opened a kind of Pandora’s box. The spirits took their abode in the minds of men like Duchamp, and brought a whirlwind of anarchy, nihilism and the gospel of absurdity. The wind is still blowing, and becoming a storm: a storm called revolution.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-150-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])])]), _vm._v(" No doubt Duchamp was “one of the most influential men of our century, a man of great intellectual ability, a man who could and did dare to risk the consequences of his thinking,” but he was also the foremost among the artists and thinkers who “accepted the truth of the absurdity of this world and this life.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-149-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" His ready-made sculptures, for instance, are mundane found cultural artifacts (a snow shovel, a bottle rack, a urinal, etc.) exhibited as works of art—acts of defiance in which the “absurdity is willed.” Rookmaaker regarded these works (partially correctly) as assaults on the very idea of “high art standing for high human values,” but he saw no constructive project or alternative theory of art in them."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-148-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])]), _vm._v(" Indeed, he regarded the project as pure antagonism: under Duchamp’s influence, like-minded artists “saw that now all values, norms, forms, traditions, all that belonged to western culture including its art, had lost their meaning. They looked for a great upheaval, the breakdown of our culture, in the acceptance of nihilism and anarchism.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-147-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Hereafter, as far as Rookmaaker is concerned, the dominant theme of modern art is that “man is dead. He is nothing but a machine, a very complex machine, an absurd machine.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-146-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])])]), _vm._v(" In fact from here on the word "), _c('i', [_vm._v("absurd")]), _vm._v(" appears dozens of times in the book and is used to characterize nearly every major artistic movement in the twentieth century."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-145-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])])]), _vm._v(" We might well expect it to be applied to Dada:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("It was Dada that tried to laugh away all that is of value in our world, a nihilistic, destructive movement of anti-art, anti-philosophy . . . a nihilistic creed of disintegration, showing the meaninglessness of all western thought, art, morals, traditions. It destroyed them by tackling them in an ironic way, with black humor, by showing them in their absurdity, by making them absurd."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-144-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("We might also expect it for surrealism, though this language gets rather overheated:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Surrealism is . . . an attitude of intellectual agony. Surrealism is revolutionary and destructive: the whole of western culture and its society are thrown away in a battle against all that exists, in a revolt against everything to which a bourgeois world had previously held firm. They were against nation, God, and reason—particularly the latter. They were against personality, conscience, beauty as an aim, talent, artistry, even the very will to live."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-143-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("The work of Paul Klee (1881–1973) is characterized as nihilistic mysticism, “a cold romanticism . . . the art of a man who knows about absurdity, chance, alienation and agony.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-142-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])])]), _vm._v(" Vasily Kandinsky (1866–1944) painted “the irrationality of the rational,” displacing traditional iconography for “a sort of volcanic, destructive force in this strange geometry.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-141-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])]), _vm._v(" And in Rookmaaker’s estimation, modernism slides downhill from there. He gives gloomy assessments of Jackson Pollock, Robert Rauschenberg, Lucio Fontana, Henry Moore, pop art, op art, happenings, minimalism, conceptualism and so on—seeing violence, “crisis, alienation, and absurdity” as characteristic to them all."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-140-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])])]), _vm._v(" Although in principle “our reaction to modern art has no need to be wholly negative,”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-139-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])])]), _vm._v(" Rookmaaker’s reaction is nevertheless overwhelmingly pessimistic. He identifies very few exceptions to the general unraveling. The Roman Catholic artist Georges Rouault (1871–1958) is presented as one of the rare artists to have shown that within a modern stylistic paradigm “another kind of art is possible . . . an art which is a positive answer to absurdity and surrealism and existentialism.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-138-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])])]), _vm._v(" But he laments that Rouault went largely unnoticed, both in the church and the art world, and he regrets the absence of any significant “Protestant counterpart” who might have helped the cause.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("By the 1960s, Rookmaaker was ready to concede that “modern art has won the battle.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-137-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])])]), _vm._v(" Modernism had gained considerable power in the major art institutions—particularly in museums and academia—and the writing of modernist art history had already been developed and codified to such an extent that it effectively defined what “the modern” means in the arts. The grain of art history now ran decisively through modernism, which came to delineate the contours (for both inclusion and exclusion) of what counted as the most significant artmaking over the past century. But as Rookmaaker read it, within these contours resided something deeply nihilistic at its core: the modernists “tell us that everything is rotten, nothingness, putrid, empty, senseless.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-136-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Whereas modernism almost always narrated itself in terms of progress—social, political, philosophical or aesthetic—Rookmaaker saw it as a story of digress into a despairing (or sneering) nihilism. In many ways he subscribed to a modern secularization narrative similar to the one articulated by Belgian art historian Thierry de Duve, who has argued that the noble function of “the best modern art” was “to redefine the essentially religious terms of humanism on belief-less bases.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-135-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])])]), _vm._v(" Rookmaaker would have basically agreed; he just saw this as profoundly tragic rather than hopeful (as it is for de Duve) and as evidence of spiritual failure rather than progress. All in all, his account plays neatly into Elkins’s narrative of the modern gulf between art and religion, with the exception that he saw only calamity where Elkins sees puzzling curiosities.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_12"
    }
  }, [_vm._v("Problems")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("For Christians (and others) who are interested in the discourse of religion and art, Rookmaaker’s work includes many important contributions. He ventured into the historical and cultural rifts between Christianity and modern art at a time when very few Christians gave it their attention, and he called others to do the same. And as he did so, he helpfully addressed and diagnosed several problems on both sides of this rift. On the one hand, much of his work urges critical self-reflection on the part of Christians, particularly regarding the gnostic, privatist and escapist renderings of the gospel that have plagued modern Christianity. In fact, it seems that he regarded this to be the hub of his project. As he wrote in one of his most famous statements, “We should remind ourselves that Christ did not come to make us Christians or to save our souls only, but that he came to redeem us in order that we might be human, in the full sense of that word. To be new people means that we can begin to act in our full, free, human capacity in all facets of our lives.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-134-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])]), _vm._v(" We could well understand all of Rookmaaker’s work as addressed to Christians, trying to get them to digest and develop the implications of that statement (particularly as it pertains to cultural theology).")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("On the other hand, as we’ve seen, he was also intent upon initiating more critical self-reflection about the meanings of modern art, especially with regard to its own visions for a “full, free, human” life. The key feature (and chief contribution) of his work on this point is that modernism was at all points theologically charged: insofar as modern art was a "), _c('i', [_vm._v("human")]), _vm._v(" enterprise, its significance is always inevitably theological at some level."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-133-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])])]), _vm._v(" And as he saw it, the deepest resources for conducting a fuller critical engagement with modern art are found within a (Reformed) Christian theological framework. James Romaine summarizes: “For Rookmaaker, there was no theologically neutral content in art. All content, whether dressed in ‘religious’ subject-matter or not, was measured in terms of its biblical truthfulness.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-132-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])])]), _vm._v(" In this respect Rookmaaker’s work greatly expanded the possibilities for theological thinking in the interpretation of modern art.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Despite these contributions, however, many who reread Rookmaaker’s book today are increasingly dissatisfied with both his methods and his conclusions. Art historian and curator Daniel Siedell has registered the most significant criticisms:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Rookmaaker’s history of Western art in general, and modern art more specifically, was crafted not so much to maximize understanding of the history of modern art but to maximize space for the Christian artist. . . . The history of modern art that it presents is intended to serve as a rhetorical tool that demonstrates culture’s need for the Christian artist."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-131-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("The result is a handling of modernism that is reductive both historically and critically, even if tactically expedient: “The tendency has been, at least since Rookmaaker, to paint as dire a picture as possible of the history of modern art and the contemporary art world” in order “to drive a significant wedge between the past of nihilistic modern art and a future where Christian artists can shape culture.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-130-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])])]), _vm._v(" Siedell worries that in fact the entire project of the contemporary “Christian artist” has been constructed such that it simply “requires a nihilistic, elitist, anti-Christian history of modern art and an impenetrable, corrupt, and inaccessible contemporary art world against which to react.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-129-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])])]), _vm._v(" This version of art history has indeed been effective in motivating large numbers of Christians in recent decades to pursue artmaking with great seriousness and intentionality, but it has also produced stifling effects. The Rookmaakerian narrative of twentieth-century art (and, as we will see later in this chapter, his alternative criteria for what good contemporary art might be) is so idiosyncratic in the current context of academic art history that adopting it as one’s own is often functionally crippling for those hoping to participate in and contribute to the primary discourses and institutions of contemporary art (as artists, critics, theorists, curators or historians).")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The central problem is that Rookmaaker’s account hinges on a theory of art that interprets visual representations as making "), _c('i', [_vm._v("ontological")]), _vm._v(" assertions about the things represented. In other words, as we have already seen, he regarded an artist’s handling of subject matter as presenting “a particular view on reality,” which thereby reveals “a whole way of thinking” about what and how "), _c('i', [_vm._v("the world is")]), _vm._v(". Of course this is one of the ways that images can function—indeed historically it was a primary function"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-128-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])])]), _vm._v("—but Rookmaaker did not adequately recognize the extent to which this is no longer the central task of "), _c('i', [_vm._v("painting")]), _vm._v(". In the context of a visual culture increasingly saturated by mass-produced photographic imagery—much of it deployed through the machinery of journalism, advertising and celebrity culture—the purposes and meanings of representations had become much more complicated and contestable, and numerous modernists embraced painting as a means of contesting or creating alternative spaces within that visual culture. This means that a modernist painting might offer much less of “a particular view on reality” than it does a particular (often particularly critical) view on image construction in the age of modernity.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("As already noted, Rookmaaker’s art theory is most clearly on display (and most clearly problematic) when he interprets the fragmentation and dissolution of pictorial space in modernist painting as an attack on or a loss of "), _c('i', [_vm._v("what")]), _vm._v(" is represented, which he finds particularly troubling when it pertains to humanity and to “reality.” This thematic approach is conspicuous throughout his work, and, interestingly, it once again plays into Elkins’s conclusions. In Rookmaaker’s discussion of nineteenth-century painting, for example, he argues that “by removing Christ, or Mary, or other Christian themes from the picture itself, leaving them outside the picture-frame, it is as if Christ himself, and the reality of the things Christians believed in, were placed outside the world.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-127-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])])]), _vm._v(" As he moves further into twentieth-century painting, the problem becomes more acute and his method more strained. For instance, he turns a critical eye toward Joan Miró (1893–1983):")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("What has become of man? Miró once painted a picture of a picture. He took a reproduction of a secondary seventeenth-century Dutch picture ["), _c('i', [_vm._v("The Lutenist")]), _vm._v(" (1661) by Hendrick Martenszoon Sorgh] (it could just as well have been a Vermeer or a Rembrandt [Miró is traipsing over Rookmaaker’s home turf here]) and gave his own reinterpretation. Nothing is more telling. Man is dead, it says. The absurd, the strange, the void, the irrationally horrible is there. The old picture is treated with humor, scorn and irony—black humor and devastating irony—until nothing is left. As the image is destroyed, so too is man."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-126-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("It is unclear why we should regard Miró’s "), _c('i', [_vm._v("Dutch Interior (I)")]), _vm._v(" (1928) as simply transposing Sorgh’s imagery into the domain of “the absurd, the strange, the void, the irrationally horrible.” We might just as readily associate it with the whimsical, the improvisational, the mystical, the intuitively playful. Indeed, Miró himself would have found the latter list to be a more appropriate description."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-125-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])])]), _vm._v(" It is also unclear why we should believe that Miró’s “picture of a picture” is making sweeping pronouncements on the topic of “man” more than it is commenting on (or critiquing) the older "), _c('i', [_vm._v("painting")]), _vm._v(" from which it was derived, or even the formal conventions of “painting” more generally.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("But it is that last statement—“as the image is destroyed, so too is man”—that most deserves our suspicion. Rookmaaker so closely associates pictorial representation with the dignity of whatever is pictured that its dismantling (or dissembling) on the surface of a modernist canvas is interpreted as a violation of the dignity of whatever is pictured, even in this case where it is a picturing of another artist’s picturing."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-124-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])])]), _vm._v(" In this way he interprets the modernist flattening and distorting of human form as a flattening and distorting of human dignity itself—and, as we have already seen him argue, "), _c('i', [_vm._v("that")]), _vm._v(" kind of flattening signals very problematic developments in the broader cultural consciousness, both ethically (dehumanization has infiltrated our vision) and epistemologically (the intelligibility of the world has fallen into question)."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-123-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])])]), _vm._v(" But why would that be the best way to interpret Miró’s painting—or “modernist painting” as a general category?")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The narrative hinge of "), _c('i', [_vm._v("Modern Art and the Death of a Culture")]), _vm._v(" is the development of Picasso’s so-called analytic cubism, which Rookmaaker refers to as his “first ‘horrible’ period.” (He proceeds to track Picasso’s progress through at least three “horrible” periods.)"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-122-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])])]), _vm._v(" Rookmaaker uses the year 1911 to mark “Picasso’s great break through the boundaries of reality,” wherein he begins painting “absurd man, absurd reality; man made up of some planks; man as non-man.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-121-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])]), _vm._v(" Once again, for Rookmaaker these paintings of humans are received as presenting a pictorial ontology of those humans—“man "), _c('i', [_vm._v("made up of")]), _vm._v(" . . . man "), _c('i', [_vm._v("as")]), _vm._v("”—as opposed to any number of other ways these paintings might be read. For fellow cubist artist and critic Jean Metzinger, for example, the significance of these paintings had little to do with the disfigured face of humanity; rather “Picasso unveils to us the very face "), _c('i', [_vm._v("of painting")]), _vm._v(". . . . I am aware of no paintings from the past, even the finest, that belong to painting as clearly as his.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-120-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])])]), _vm._v(" In fact, he believed that the discontinuity and fragmentation of Picasso’s pictorial space follows from a "), _c('i', [_vm._v("realist")]), _vm._v(" impulse to include the passage of time (and the shifting position of the artist in space) in the construction of the image: “Whether it be a face or a fruit he is painting, the total image radiates in time; the picture is no longer a dead portion of space.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-119-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])])]), _vm._v(" Alternatively, for the famous American art critic Leo Steinberg, “semiotics” (rather than ontology) was the right handle for interpreting cubism: “In the end, the materials of Picasso’s gerrymandering are not heads as such, since these come with their proper structure of slopes and planes, but those remembered "), _c('i', [_vm._v("signs that stand for")]), _vm._v(" eye, mouth, oval perimeter, and so forth.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-118-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The point here is that the problems of analytic cubism might have less to do with "), _c('i', [_vm._v("what humans are")]), _vm._v(" than with what it means for a human likeness (or any likeness) to be presented in the rectangular flatness of the canvas. That was the philosophical (or semiotic) set of problems that analytic cubism was designed to address. We emphasize this here because much of one’s reading of modernism—and certainly one’s theological reading of modernism—turns on this. By all accounts there was some sort of deep doubt being worked through in Picasso’s gerrymandering; but we come to very different conclusions about the significance of that doubt if we understand it in terms of Steinberg’s “signs "), _c('i', [_vm._v("that stand for")]), _vm._v("” versus Rookmaaker’s “man "), _c('i', [_vm._v("made up of")]), _vm._v("”—the first an interrogation of Western visual language in a photographic age, the second an effacement of human dignity. Perhaps the artist’s “worldview” is also discernible in Steinberg’s hermeneutic, but it stands forth in a different way than Rookmaaker anticipates."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-117-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("As might be expected from his art theory, Rookmaaker had a strained relationship with abstract painting. He praised the use of abstract formal elements in the fields of functional or commercial design, where these elements are “appropriate to their function, because they have no pretentions to mean something of great depth.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-116-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])])]), _vm._v(" Within the discursive context of an exhibition space, however, he interpreted abstract painting primarily in terms of epistemic "), _c('i', [_vm._v("negation")]), _vm._v(": it is “the breaking down of the clear image, the failure to retain the natural.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-115-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])])]), _vm._v(" If Picasso took the decisive step in the shattering of art’s capacity to convey the goodness and the intelligibility of the world, then abstract artists seemingly abdicated the responsibility altogether. Rookmaaker regarded abstraction as a (gnostic) search for universals that operated specifically by turning away from the world and attempting “to build something detached from reality.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-114-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])])]), _vm._v(" He agreed with Sedlmayr that art generally loses its meaning and comprehensibility “when people seek to depict through it basic principles of reality without referring to anything concrete. For it is a fact that abstract concepts can never be grasped as such. . . . [They] appear only when one divests concrete givens of their concrete characteristics.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-113-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])])]), _vm._v(" In contrast to abstract painting, he believed that “a "), _c('i', [_vm._v("Street")]), _vm._v(" by Vermeer or a "), _c('i', [_vm._v("St. Nicholas")]), _vm._v(" "), _c('i', [_vm._v("Morning")]), _vm._v(" by Jan Steen offers us much more. . . . In and with these objects something of value is told us that can never be given in separation from them, for then I would either be saying nothing or else no one would be able to understand me.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-112-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("It is unclear, however, why Rookmaaker did not recognize the painted surface itself as a constellation of meaningful “concrete givens,” offering “something of value” that can never be given apart from that surface. In other words, why doesn’t Rookmaaker’s advocacy for artworks exploring the goodness of creaturely reality extend to the materiality of painting itself and the extraordinary range of (abstract) formal relationships possible within it? He generally continued interpreting abstraction in essentially pictorial terms, ignoring the variety of other factors (and critical possibilities) at work in an encounter with abstract painting. The American art critic Donald Kuspit sharply criticized the tendency by which “philosophy exaggerates the artwork into an epistemological problem, into the problem of epistemology itself,” thus obscuring “the concreteness that is the source of the artwork’s intense particularity.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-111-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])])]), _vm._v(" Rookmaaker would appear to fall squarely under the weight of that critique.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_13"
    }
  }, [_vm._v("Discerning the Spirits")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Even if Rookmaaker’s representational theory of art predisposed him toward a negative reading of modern art, this still does not fully account for the tremendous momentum that pushes his three-step narrative along its downward path. A further reason that he read modernist paintings in the way he did becomes clearer as we return to his claim that the issues at stake in the arts are “not just cultural and intellectual but spiritual.” As he saw it, the spiritual issues involved here were not merely individual (as though "), _c('i', [_vm._v("spiritual")]), _vm._v(" were simply synonymous with some aspect of private experience); they were also caught up in the more costly conflicts among spiritual “principalities and powers.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-110-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])])]), _vm._v(" Throughout his writing he regularly referenced (sometimes directly, sometimes allusively) Paul’s caution to the early church in Ephesus: “For we wrestle not against flesh and blood, but against principalities, against powers, against the rulers of the darkness of this world, against spiritual wickedness in high places” (Eph 6:12 "), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("KJV")]), _vm._v(")."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-109-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])])]), _vm._v(" Rookmaaker regarded modernist art as one site where this wrestling was obviously going on (and generally being lost) in Western culture, and as such the artistic discourse could not for him be simply academic or aesthetic; he thought the stakes were extremely high.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("For this reason, even if he was highly critical of the work of Picasso (to take one example), he was not dismissive of it. This is perhaps most exemplified in Rookmaaker’s biting review of J. M. Prange’s cranky screed against modern art in his book "), _c('i', [_vm._v("The God Hai-Hai and Rhubarb")]), _vm._v(". Prange’s book mockingly characterized modernism as a pseudocultic spectacle equivalent to worshiping an invented god named Hai-Hai. What makes Rookmaaker’s review especially interesting—and illuminating of his own criticisms of modernists like Picasso—is the basis of his critique:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The question remains who the god Hai-Hai is. . . . For what Prange did is mortally dangerous. He says to us: this god is not there, it is pure bluff, idle sputtering and empty raving. But for all that this god, the spirit of the century, "), _c('i', [_vm._v("is")]), _vm._v(" there to be sure, and force of error though it may be, this god is in any case a deeply spiritual reality that we cannot just frivolously kick aside. Those who really want to be engaged in today’s spiritual struggle must take their opponent seriously. . . . Prange reports that he stood in front of Picasso’s "), _c('i', [_vm._v("Guernica")]), _vm._v(" and laughed; he ought to have wept."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-108-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Rookmaaker firmly believed that modern artworks like "), _c('i', [_vm._v("Guernica")]), _vm._v(" were key contributors not only in the drama of human values and ideologies but also in the drama of human allegiances to real spiritual forces and regimes. It was no laughing matter. And he felt that this aspect of the life of a culture—­including the history of art—must be named and considered: this spiritual ­dimension “exists and endures as a power that one may not mentally dismiss without falsifying or even rendering impossible one’s apprehension of today’s world.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-107-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])])]), _vm._v(" However, one can also see why engaging art in terms of “today’s spiritual struggle” against “the spirit of the century” would make it impossible for Rookmaaker to interpret Picasso’s cubism, or any other work like it, within the more modest framework of Metzinger’s formalism or Steinberg’s semiotics. The prospect of offering a theologically informed account that runs alternative to Rookmaaker probably necessitates arguing for a different “discernment of the spirits” in the history of modern art—one that sees the Holy Spirit as more active in that history than Rookmaaker realized.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_14"
    }
  }, [_vm._v("The Question of Norms")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Perhaps the crux of the issue becomes clearer as we investigate Rookmaaker’s use of the term "), _c('i', [_vm._v("normal")]), _vm._v(", which appears regularly throughout the book and is a key to his interpretive process—in fact, it functions as the counterpart to "), _c('i', [_vm._v("absurd")]), _vm._v(", both in meaning and frequency of usage. He usually places the word in quotation marks, as if to indicate his discomfort with its connotations, but he continues to make it carry content. He refers to the concrete surrealists (such as Dalí and Magritte) as presenting a world that is intensely “abnormal” and irrational, but they do so through “meticulously precise painted images, ‘normal’ as far as technique goes.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-106-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])])]), _vm._v(" He also directs our attention to a 1918 painting in which Picasso painted his first wife, Olga, “in a ‘normal’ way, resembling an Ingres portrait.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-105-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])])]), _vm._v(" In these examples "), _c('i', [_vm._v("normal")]), _vm._v(" apparently refers to the construction of traditional pictorial space—however surreal or idealized the subject matter may be—rendering light, volume and spatial depth “in an almost normal way, as any classicist would have done.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-104-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])])]), _vm._v(" The term thus designates a "), _c('i', [_vm._v("familiar")]), _vm._v(" sense of form in space.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("But this is not to imply that by "), _c('i', [_vm._v("normal")]), _vm._v(" he simply meant naturalistic. The kind of familiarity he had in mind was richer than that: it had more to do with one’s sense that an artwork articulates something about “reality in its fullness.” Early in the book, for example, he praised “the naturalness, the full humanity” of Jan Steen’s "), _c('i', [_vm._v("The Feast of Saint Nicholas")]), _vm._v(" (c. 1665–1668), which he admired because the naturalistic rendering was not simply for its own sake but was “controlled by a true insight into reality, an insight that must have a deep foundation, one that really leads to the opening up of reality. The very normality of the picture is founded in a deep understanding, a ‘philosophy.’”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-103-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])])]), _vm._v(" Achieving this generative insight into “normal” reality was the central issue; and while this insight might propel an artist toward the pictorial naturalism of paintings like Steen’s, it might also potentially demand other approaches to painting. In his discussions of Georges Rouault, for instance, Rookmaaker argued that modernist painting offers valuable correctives to more strictly naturalistic ways of conceptualizing this “opening up of reality”:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Undoubtedly one must count it as one of the positive renewals brought about by modern art that it broke with the naturalistic notion that, in the art of painting, the effort must be made to render [natural] reality as exactly as possible. For . . . reality is more than its natural aspect, which was all that naturalism ever had an eye for, at least when it was consistent. No, art must not just render the visible, external, measurable and weighable. Far from it. It also can and should depict reality in its fullness."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-102-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("This potential (or necessity) for artworks to disclose everyday reality with a stronger sense of its unquantifiable “fullness” was one of Rookmaaker’s highest values in the visual arts, and it was precisely this potential that he thought modernism could have been well poised to actualize. But it was also by these same criteria—the presentation of a fuller vision of humanity and the dense meaningfulness of the world—that he found modern art to be most tragically disappointing (or offensive): it disfigured “the visible, external, measurable and weighable” rather than offering a fuller vision of it. In contrast to the tradition that gave us Diego Velázquez’s painting of "), _c('i', [_vm._v("Pope Innocent X")]), _vm._v(" (1650), for example, which is “very human, very ‘normal,’ very beautiful and very much the great man,” modernism has given us the “paralytic, neurotic, leprous schizoids” of Francis Bacon’s numerous appropriations of Velázquez’s portrait (1946–1965)."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-101-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])])]), _vm._v(" In fact Rookmaaker took this contrast to be exemplary: it is no accident that one of Bacon’s screaming popes ("), _c('i', [_vm._v("Head VI")]), _vm._v(", 1949) appears on the cover of "), _c('i', [_vm._v("Modern Art and the Death of a Culture")]), _vm._v(" as a quintessentially modernist icon.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Of course none of this is simply a stylistic matter; Rookmaaker believed that pictorial aesthetics were intrinsically linked to ethics. For instance, he interpreted Picasso’s return to the more traditional representational style of his “classicist” period (roughly 1917–1924) as denoting “a more ‘loving’ and free expression when he loves a woman,” in contradistinction to the misogynistic pictorial violence of his “more absurd, more cubist” style."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-100-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])])]), _vm._v(" This associating of violence with cubism was bolstered by the presumption that Picasso generally would “begin with a ‘normal’ drawing, and then he would begin to change it, each picture going further than the last. It gets more cubistic, loses more and more of its normal appearance, is reduced to almost nothing.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-099-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])])]), _vm._v(" As is consistent with everything we’ve already seen from his theory of art, Rookmaaker interpreted this violating of “normal appearance” as in some sense a violating of the persons and places being pictured.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The deeper reasoning supporting all of this comes into view when Rookmaaker frames his notion of “normal” (or reveals that for him it was always framed) as a theological category: “When things are in accordance with God’s created possibilities and his will for his world, they are just ‘normal.’ When love reigns in a community, that community is not strange but healthy.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-098-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])])]), _vm._v(" The concept of “normal” that weaves throughout his writing is thus ultimately an appeal to “the structures and norms [that] are universal and given by God in Creation.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-097-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])])]), _vm._v(" And it is an appeal made while acknowledging an extraordinary sense of contingency about the ways that we (ab)use these structures and (mis)realize these norms—a contingency that is inscribed into the “when” in those previous sentences. Rookmaaker believed that the structures of creation are open structures and the norms are the patterns most conducive to systemic organic health, but they are not deterministic: they determine the range of healthy (and unhealthy) possibility, “but we have to give form to this possibility. We have to make it concrete, for the universal structures and norms never exist as universals but always in specific, concrete and individual forms. Reality is always the concrete realization of a given possibility.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-096-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])])]), _vm._v(" And, as should be expected, Rookmaaker’s conceptualization of both evil (systemic destructive "), _c('i', [_vm._v("ab")]), _vm._v("normality) and salvation (restoration into a fullness of life) are tightly aligned with this framework: “Christ came for the very purpose of breaking through the reign of evil and sin and suffering. He came to make the world normal.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-095-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("And thus followed his philosophy of art: his advocacy for “works which are more human and normal”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-094-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])])]), _vm._v(" was grounded in a concern to care for and cultivate the “norms” of the created order and of flourishing human life. Rookmaaker’s book culminates with a program for “Faith and Art” (as his final chapter is titled)"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-093-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])])]), _vm._v(" in which he argued that good art is that which embodies and adheres to the “norms for art,” which “are in fact basically no different from the norms for the whole of life. Art belongs to human life, is part of it, and obeys the same rules.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-092-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])])]), _vm._v(" Using Philippians 4:8 as his springboard, he identified six norms for art (and for life): (1) truth/honesty, (2) honor/decorum, (3) righteousness/fittingness, (4) purity/goodness, (5) loveliness/beauty and (6) excellence/praiseworthiness."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-091-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])])]), _vm._v(" And once again aesthetics are tightly linked to ethics: to eschew any of these norms as an artist “is to do wrong to the beholder, to fall short of being truly loving”:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("For basically these norms are all aspects of the great command to love. Love is the great norm, in art as well. Love is to make things that are right and fitting, to help our fellow-man, to make this world more beautiful, more harmonious, more suitable for human living, more suitable for expressing that inner beauty and love for which all men are searching. . . . Beauty, as it were, is a by-product of love, of life in its full sense, of life in love and freedom."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-090-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("The artist’s task, his or her “very special and wonderful calling,” is therefore “to make life better, more worthwhile, to create the sound, the shape, the tale, the decoration, the environment that is meaningful and lovely and a joy to mankind.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-089-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("On the one hand, this is a vision well worth affirming: Rookmaaker’s core concern is to advocate for an art that is principally oriented by love of God and love of neighbor. His critique of modernist art was that even though it may have rightly rebelled against the unjust and dehumanizing aspects of modernity, it in turn demonstrated its own kinds of cruelty and diminished, rather than contributed to, the reconciliation and flourishing of others. That is a critique that should be taken quite seriously.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("On the other hand, his formulation of the “norms for art” also suffers from some serious weaknesses: (1) Perhaps strangely, it fostered impatience and defensiveness in Rookmaaker’s interpretive and critical engagements with artworks. His summary statements of one artist’s career after another tended toward reductive, even uncharitable, readings of their works. Early on he arrived at the conviction that “"), _c('i', [_vm._v("abnormality")]), _vm._v(", strangeness and distortion are part of the very essence of modern art,”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-088-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])])]), _vm._v(" and this caused him to eschew much more of modernism than he should have. There was in fact a great deal more in modern art that was life-affirming and concerned with the spiritual ­well-being of others—perhaps even lovingly so—and Rookmaaker missed much of it as it was screened out by his normative formulations. (2) A further problem is that his countervailing directive “to create the sound, the shape, the tale, the decoration, the environment that is meaningful and lovely and a joy to mankind” is, practically speaking, extremely susceptible to becoming an essentially decorative and consumerist conceptualization of the arts. In fact, this susceptibility becomes blatant as Rookmaaker identified what he saw as positive and viable alternatives to modernism:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Maybe the real art of our times, comprising both the aesthetic and the imagination and command of technique, is to be found in advertising, or in magazine layout, or in the graphic design of leaflets or even in scientific drawings. Or there is the often very fine visual means of depicting statistics, and so on. The forms are often strongly influenced by modern “high” art, but they have got a meaning, a sense, have become “normal” and to the point. . . . Perhaps too most real art today is in television. There are not only the often very imaginative openings, using drawings, letters, animated figures, photography and so on, but also the representation of many aspects of reality. . . . The message is often hard-core reality, “facts” themselves, and that is all."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-087-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("In one sense, his recognition of popular culture as a primary site of aesthetic and religious value (and the challenge this poses to high-low cultural dichotomies) was progressive for its time. But it is also precisely here that we get Rookmaaker’s extremely conservative criteria for “real art”: it (1) is aesthetically beautiful, (2) is imaginative, (3) displays a command of technique, (4) can be absorbed by viewers as fairly “normal” and “to the point,” and (5) represents the “facts” of reality. In the context of the discourse of modernism these criteria—and especially their identification with advertising, scientific charts and television—are extremely problematic for Rookmaaker’s position. Not only is looking to advertising and television for messages of “hard-core reality” highly contestable,"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-086-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])])]), _vm._v(" he has, in the interest of cultivating a more loving art, essentially collapsed the space for criticality, difficulty or even intellectual complexity within the category of “real art.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("To further complicate things, there is another “normal” in Rookmaaker’s work that amplifies problems on precisely this issue. Near the end of his book Rookmaaker presumably confronts the question directly in a section titled “What is normal?”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-085-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])])]), _vm._v(" In stark contrast to his other uses of the term, however, here he associates “normal human life” with the “bourgeois mentality,” which he sharply criticized as embodying “this lack of commitment, this lack of real values, this lack of ‘daring to live.’ The shallowness and emptiness are appalling.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-084-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The problem is that when Rookmaaker speaks of norms, he has at least two sets in mind: on the one hand "), _c('i', [_vm._v("normal")]), _vm._v(" refers to a healthy adherence to God-given “law-spheres” (as Dooyeweerd called them), and on the other hand it refers to socially constructed systems—including traditions of art—which are often death-dealing and oppressive."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-083-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])])]), _vm._v(" This ambiguity causes deep problems for Rookmaaker’s art criticism: while one might appreciate the Reformed notion, it becomes difficult to tell how these norms are rightly distinguished from those of the “bourgeois mentality” that Rookmaaker believed should be resisted. And this difficulty becomes especially acute with regard to modernist art: given its persistent violations of traditional visual norms and bourgeois visual culture, it becomes difficult to sort out which normal is really under attack and which should and should not be defended within the Rookmaakerian schema. Perhaps it is true, for example, that “Dada’s black humor can only live in the negation of, or in play with, these norms,”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-082-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])])]), _vm._v(" but in the midst of the catastrophic pain of World War I, how are we to decide "), _c('i', [_vm._v("which")]), _vm._v(" norms Dada was really working to negate? (We will consider this question further in chapter five.)")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Still, in light of (or despite) all of this, Rookmaaker’s work has been helpful to generations of Christians active in the arts, and his overall influence has been positive. His reading of modern art was flawed, but his consistent aim was to urge fellow Christians toward a fuller and more intensely constructive vision for the arts: “Christianity is about the renewal of life. Therefore it is also about the renewal of art. . . . It is for Christians to show what is meant by life and humanity; and to express what it means for them to have been ‘made new’ in Christ, in every aspect of their being.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-081-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])])]), _vm._v(" In his lecture tours throughout the United States and Britain, in his university teaching and in his later writings he emerged as one of the most encouraging voices in support of Christian involvement in the arts, a voice that was sadly cut short by his sudden death in 1977 (when he was only fifty-five years old).")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_15"
    }
  }, [_vm._v("Rethinking Modernism (With and Without Rookmaaker)")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Within the framework developed in these first two chapters, the chapters that follow in part two offer some avenues for rethinking the religious contexts and the theological implications of the history of modern art. And in this Rookmaaker’s work provides more of a starting point than an orientation: these avenues will function as "), _c('i', [_vm._v("alternative")]), _vm._v(" routes to those that Rookmaaker forged. We will refer to him occasionally in the following pages (sometimes only in footnotes), signaling some important points where our understandings of particular artists are especially divergent from his, but we are not interested in aligning our remaining chapters into a tit-for-tat engagement with his positions. Nor are we interested in simply revising or repackaging his narrative; we are offering a different account, one that places the emphases on other points and approaches from other angles.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In the following studies we will, however, restrict ourselves to the general geography and time period of Rookmaaker’s book: namely, North Atlantic modernism from about 1800 to 1970, the year that "), _c('i', [_vm._v("Modern Art and the Death of a Culture")]), _vm._v(" was first published. But our remaining chapters will follow a different logic than his: our investigations will be arranged more geographically than chronologically (allowing us to highlight cultural contexts that were broadly Catholic, Orthodox or Protestant), and we will overlook numerous artists that Rookmaaker included in his account, instead slowing down to focus more carefully on fewer artists. Our primary conversation partners will shift from Rookmaaker to a selection of critics and art historians who have significantly contributed to the scholarship on the artists who will concern us. Obviously we cannot be comprehensive here—with respect to either our selection of artists or to our engagement with the massive literature on each of the artists that we will discuss—but we hope to highlight at least some of the significant religious influences and theological meanings that are too often left buried in the academic literature. Part of what the remaining chapters seek to do is to make the resources of this literature available to a wider (or at least to another) readership, including people of faith (of whatever tradition) who are interested in modern art.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We might frame our larger goal as an attempt to encourage a greater interpretive generosity—or what we called in the first chapter a more “charitable hermeneutic”—within the discourse of modern art. If the narratives of modernism have often been too narrowly framed in political or formal aesthetic terms, to the exclusion of adept religious and theological thinking, then religious believers (including Rookmaaker) have also often approached and evaluated modern art within narrow religious grids. While not denying the importance of any of these available critical frames—whether secular or religious—we want to expand our vision to consider the ways that these multiple frames and impulses intermingle in modern artworks and issue organically from the cultural and religious contexts in which the artists worked. The following chapters represent a few steps forward in these considerations, and we hope that others who are perhaps sparked (or provoked) by what we write will take the next steps.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3106701d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch2.vue
// module id = 75
// module chunks = 0